import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import IntegrationBreadcrumb from "components/Integration/components/IntegrationBreadcrumb"
import {
  fetchMarketoFields,
  fetchMarketoMappings,
  patchMarketoMappings
} from "app/modules/marketo/actions"
import { fetchAttributes } from "app/modules/endUser/attribute/actions"
import { filteredProperties } from "app/modules/endUser/attribute/selectors"
import {
  getFields,
  getMappings,
  didPatchErr,
  isPatchLoading,
  isAllowAttributeDefaults,
  isUseStateAcronyms,
  isUseCountryAcronyms
} from "app/modules/marketo/selectors"
import AttributeMapper from "../../components/AttributeMapper"
import { MarketoMapping } from "app/modules/marketo/models"
import { Input } from "@driftt/tide-core-legacy"
import withNotifications from "components/shared/notifications"

import "./style.styl"

const HELP_DOC_URL =
  "https://help.drift.com/integrations/marketo-attribute-mapping"
const integrationName = "Marketo"
const getSuccessMessage = integrationName =>
  `You successfully updated your ${integrationName} App!`

class MarketoAttributeMapping extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mappings: props.mappings,
      useCountryAcronyms: props.useCountryAcronyms,
      useStateAcronyms: props.useStateAcronyms,
      allowAttributeDefaults: props.allowAttributeDefaults
    }
  }

  createDefaultMapping = (mappings) => {
    return mappings.map(mapping =>
    mapping.driftAttribute && mapping.defaultValue
      ? Object.assign(mapping, { defaultValue: null })
      : mapping)
  }

  onCountryUpdated = () => {
    const {
      mappings, allowAttributeDefaults, useStateAcronyms, useCountryAcronyms
    } = this.state

    const payload = {
      mappings:  mappings,
      allowAttributeDefaults,
      useStateAcronyms,
      useCountryAcronyms: !useCountryAcronyms
    }

    this.updateMappings(payload)
  }

  onStateUpdated = () => {
    const {
      mappings, allowAttributeDefaults, useStateAcronyms, useCountryAcronyms
    } = this.state

    const payload = {
      mappings: mappings,
      allowAttributeDefaults,
      useStateAcronyms: !useStateAcronyms,
      useCountryAcronyms,
    }

    this.updateMappings(payload)
  }

  onDefaultUpdated = () => {
    const {
      mappings, allowAttributeDefaults, useStateAcronyms, useCountryAcronyms
    } = this.state

    const payload = {
      mappings:  this.createDefaultMapping(mappings),
      allowAttributeDefaults: !allowAttributeDefaults,
      useStateAcronyms,
      useCountryAcronyms
    }

    this.updateMappings(payload)
  }

  updateMappings = (payload) => {
    const { notifications } = this.props

    this.props.actions.patchMarketoMappings(payload, () => {
      notifications.success(getSuccessMessage(integrationName))
      // Update UI with the new state after success.
      this.setState({ ...payload })
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.allowAttributeDefaults !== nextProps.allowAttributeDefaults) {
      this.setState({ allowAttributeDefaults: nextProps.allowAttributeDefaults })
    }
    if (this.state.mappings !== nextProps.mappings) {
      this.setState({ mappings: nextProps.mappings })
    }
    if (this.state.useCountryAcronyms !== nextProps.useCountryAcronyms) {
      this.setState({ useCountryAcronyms: nextProps.useCountryAcronyms })
    }
    if (this.state.useStateAcronyms !== nextProps.useStateAcronyms) {
      this.setState({ useStateAcronyms: nextProps.useStateAcronyms })
    }
  }

  componentDidMount() {
    this.props.actions.fetchDriftProperties()
    this.props.actions.fetchMarketoFields()
    this.props.actions.fetchMarketoMappings()
  }

  patchDecorator = (strippedMappings, successCB) => {
    const {
      allowAttributeDefaults,
      useCountryAcronyms,
      useStateAcronyms
    } = this.state
    const payload = {
      mappings: strippedMappings,
      allowAttributeDefaults,
      useCountryAcronyms,
      useStateAcronyms
    }
    this.props.actions.patchMarketoMappings(payload, successCB)
  }

  render() {
    const { patchLoading, driftProperties, marketoFields } = this.props
    const {
      mappings,
      allowAttributeDefaults,
      useCountryAcronyms,
      useStateAcronyms
    } = this.state

    return (
      <div className="marketo-mapping common-integration-page-layout">
        <IntegrationBreadcrumb
          backLinkText="Marketo Integration"
          backLinkUrl="/settings/setup/marketo"
        />
        <header>
          <h2 className="integration-header">Mapped Marketo Attributes</h2>
          <p>
            {" "}
            Map which fields you want to add to new Marketo Leads. These Drift
            attributes will be added to new Marketo Leads when they’re created.
            <a href={HELP_DOC_URL}> Learn More</a>
          </p>
        </header>
        <AttributeMapper
          integrationName="Marketo"
          mappings={mappings}
          driftAttributes={driftProperties}
          integrationAttributes={marketoFields}
          mappingModel={MarketoMapping}
          patchMappings={this.patchDecorator}
          patchLoading={patchLoading}
          allowAttributeDefaults={allowAttributeDefaults}
        />
        <div className="marketo-toggle-row">
          <Input
            className="marketo-default-checkbox"
            type="checkbox"
            checked={allowAttributeDefaults}
            onChange={this.onDefaultUpdated}
          />
          <h1 className="marketo-toggle-text">
            Set default values that will send when a Drift Attribute is empty
          </h1>
        </div>
        <div className="marketo-toggle-row">
          <Input
            className="marketo-default-checkbox"
            type="checkbox"
            checked={useCountryAcronyms}
            onChange={this.onCountryUpdated}
          />
          <h1 className="marketo-toggle-text">
            Send abbreviated country names to Marketo (i.e. US instead of United States)
          </h1>
        </div>
        <div className="marketo-toggle-row">
          <Input
            className="marketo-default-checkbox"
            type="checkbox"
            checked={useStateAcronyms}
            onChange={this.onStateUpdated}
          />
          <h1 className="marketo-toggle-text">
            Send abbreviated state names to Marketo (i.e. NY instead of New York)
          </h1>
        </div>
      </div>
    )
  }
}

MarketoAttributeMapping.defaultProps = {
  allowAttributeDefaults: false,
  useStateAcronyms: false,
  useCountryAcronyms: false
}

function mapStateToProps(state) {
  return {
    driftProperties: filteredProperties(state),
    mappings: getMappings(state),
    marketoFields: getFields(state),
    patchError: didPatchErr(state),
    patchLoading: isPatchLoading(state),
    allowAttributeDefaults: isAllowAttributeDefaults(state),
    useCountryAcronyms: isUseCountryAcronyms(state),
    useStateAcronyms: isUseStateAcronyms(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchDriftProperties: fetchAttributes,
        fetchMarketoMappings,
        fetchMarketoFields,
        patchMarketoMappings
      },
      dispatch
    )
  }
}

export default withNotifications(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MarketoAttributeMapping)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoAttributeMapping/index.js